import axios from "axios";
import { dashboardConstants } from "../constants";

export const getTipoDocumentos = () => async (dispatch) => {
  dispatch(request());
  try {
    const response = await axios.get("https://wsrfa.sannicolasciudad.gob.ar/listados/dtTipoDoc.php");

    if (typeof response === "string") {
      dispatch(failure(response?.data));
    } else {
      dispatch(success(response?.data));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.TIPO_DOCUMENTO, payload: data };
  }
};